<script>
  import { numberToOrdinal } from '$lib/math';
  import Handlebars from 'handlebars';
  import { marked } from 'marked';
  import { partyToColour, partyToLabel } from '$lib/constants/index';
  import { valueType } from '$lib/constants/crosswalk';
  import { formatValue } from '$lib/utils';
  let { block, smartVars } = $props();

  const partySpan = (key) =>
    `<span style="background-color:${partyToColour(key)}">${partyToLabel(key)}</span>`;

  // Handlebars has no arithmetic operators, but the rngs.io template writes
  // plain expressions like `{{{ oppositionTotal - governingCoalition }}}` —
  // evaluate those against the known numeric vars before compiling, so the
  // template only ever sees simple `{{{ var }}}` lookups.
  const numericVars = {
    oppositionTotal: smartVars.oppositionTotal,
    governingCoalition: smartVars.governingCoalition,
  };

  const rawTemplate = block.template.replace(
    /\{\{\{\s*([\w.]+)\s*([+\-*/])\s*([\w.]+)\s*\}\}\}/g,
    (match, left, op, right) => {
      if (!(left in numericVars) || !(right in numericVars)) return match;
      const a = numericVars[left];
      const b = numericVars[right];
      if (a === null || a === undefined || b === null || b === undefined)
        return '';
      const result =
        op === '+' ? a + b
        : op === '-' ? a - b
        : op === '*' ? a * b
        : a / b;
      return formatValue(result, valueType);
    }
  );

  const text = marked(rawTemplate);
  const template = Handlebars.compile(text);

  const vars = {
    leadingParty:
      smartVars.leadingParty ? partySpan(smartVars.leadingParty) : '',
    secondParty: smartVars.secondParty ? partySpan(smartVars.secondParty) : '',
    points:
      smartVars.points !== null ? formatValue(smartVars.points, valueType) : '',
    partiesTied: Number(formatValue(smartVars.points, valueType)) === 0,
    oppositionTotal:
      smartVars.oppositionTotal !== null ?
        formatValue(smartVars.oppositionTotal, valueType)
      : '',
    governingCoalition:
      smartVars.governingCoalition !== null ?
        formatValue(smartVars.governingCoalition, valueType)
      : '',
    oppositionLeads:
      smartVars.oppositionTotal !== null &&
      smartVars.governingCoalition !== null &&
      smartVars.oppositionTotal > smartVars.governingCoalition,
    trackedGainParty:
      smartVars.trackedGain ? partySpan(smartVars.trackedGain.key) : '',
    trackedGainValue:
      smartVars.trackedGain ?
        formatValue(smartVars.trackedGain.value, valueType)
      : '',
    trackedLossParty:
      smartVars.trackedLoss ? partySpan(smartVars.trackedLoss.key) : '',
    trackedLossValue:
      smartVars.trackedLoss ?
        formatValue(Math.abs(smartVars.trackedLoss.value), valueType)
      : '',
    trackedLossPlace:
      smartVars.trackedLoss ? numberToOrdinal(smartVars.trackedLoss.place) : '',
  };
</script>

<div class="smart-text">
  {@html template(vars)}
</div>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .smart-text {
    @include mixins.font-knowledge;
    margin: 42px 0px 0px 0px;
    padding: 0;
    :global {
      p {
        margin: 0;
        // the reset sets font-family directly on `p`, which always beats an
        // inherited value from `.smart-text` above — has to be declared here
        @include mixins.font-knowledge;
        @include mixins.text-base;
      }
      span {
        font-weight: 700;
        // font-family: var(--theme-font-family-sans-serif);
        @include mixins.font-knowledge;

        color: white;
        padding: 2px 4px;
        border-radius: 4px;
        margin: 0 2px;
      }
    }
  }
</style>
